import { ADD_UI_ERROR } from './constants';

/**
 * @file This error is meant to be displayed in the UI. A good example of this is handling
 * a specific response code and showing an error message on the page instead of routing.
 */
export function addUiErrorAction({ errorMessage, errorRef }) {
  return {
    type: ADD_UI_ERROR,
    errorMessage,
    errorRef,
  };
}

export function reducer(state, { type, errorMessage, errorRef }) {
  switch (type) {
    case ADD_UI_ERROR:
      return {
        ...state,
        uiError: {
          errorMessage,
          errorRef,
        },
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/agent-coaching/redux/addUiError.js